import React from 'react';
import AhriSystemShopWidget from '../../../AhriSystemShopWidget/src/AhriSystemShopWidget.jsx';
import '../../../AhriSystemShopWidget/src/ahri-system-shop-widget.css';
import { useAuth } from '../contexts/AuthContext';
import { API_BASE_URL } from '../config';

export default function AhriSystemShopV2() {
  const { apiKey, account } = useAuth();

  const isOAuth = Boolean(account?.accountId);

  return (
    <div style={{ margin: '-1rem -1rem -1rem -1rem' }}>
      <AhriSystemShopWidget
        apiEndpoint={API_BASE_URL}
        {...(isOAuth ? { accessToken: apiKey } : { apiKey })}
        accountId={account?.accountId ?? account?.id ?? ""}
        routeContext="ahri/shop/v2"
        title="AHRI System Shop"
      />
    </div>
  );
}
